{
  "schema": "collaborative-state-demos-fixture-provenance-v1",
  "source_document": "draft-jurkovikj-json-three-way-merge-00",
  "source_url": "https://datatracker.ietf.org/doc/draft-jurkovikj-json-three-way-merge/",
  "source_role": "machine-readable companion to the 41 vectors published in Appendix B",
  "source_bytes": 14378,
  "source_sha256": "13467e8bf70718bdf247da4b007730e4f0e560f538db6a86f92a88a457c35e62",
  "vector_count": 41,
  "captured_on": "2026-08-05"
}

